export default __webpack_public_path__ + "static/media/readme-home.6bd4ee0c.png";